import * as PatientListV4I from "./PatientListV4";
import * as ExamV4I from "./ExamV4";
import * as PatientOrdersV4I from "./PatientOrdersV4";
import * as MultidisciplinaryV4I from "./MultidisciplinaryV4";
import * as OrderSheetV4I from "./OrderSheetV4";
import * as OrderAppointmentV4I from "./OrderAppointmentV4";
import * as ResultSummaryV4I from "./ResultSummaryV4";
import * as PatientHistoryV4I from "./PatientHistoryV4";
import * as DocumentV4I from "./DocumentV4";
import * as RegistrationV4I from "./RegistrationV4";
import * as TeleHealthV4I from "./TeleHealthV4";
import * as PackageV4I from "./PackageV4";
import * as BillingV4I from "./BillingV4";
import * as BillingHistoryV4I from "./BillingHistoryV4";
import * as BillingWalletV4I from "./BillingWalletV4";
import * as ScreenV4I from "./ScreenV4";

const SequencePattern: {
  [name: string]: { [flavor: string]: { [func: string]: any } };
} = {
  ScreenV4: {
    default: {
      START: ScreenV4I.Start,
      Action: ScreenV4I.Action,
      ...ScreenV4I.SequenceIndex,
    },
  },
  DocumentV4: {
    default: {
      START: DocumentV4I.Start,
      Action: DocumentV4I.Action,
    },
  },
  PatientListV4: {
    default: {
      START: PatientListV4I.Start,
      Action: PatientListV4I.Action,
    },
  },
  ExamV4: {
    default: {
      START: ExamV4I.Start,
      Action: ExamV4I.Action,
    },
  },
  PatientOrdersV4: {
    default: {
      START: PatientOrdersV4I.Start,
      Action: PatientOrdersV4I.Action,
    },
  },
  MultidisciplinaryV4: {
    default: {
      START: MultidisciplinaryV4I.Start,
      Action: MultidisciplinaryV4I.Action,
    },
  },
  OrderSheetV4: {
    default: {
      START: OrderSheetV4I.Start,
      Action: OrderSheetV4I.Action,
    },
  },
  OrderAppointmentV4: {
    default: {
      START: OrderAppointmentV4I.Start,
      Action: OrderAppointmentV4I.Action,
    },
  },
  ResultSummaryV4: {
    default: {
      START: ResultSummaryV4I.Start,
      Action: ResultSummaryV4I.Action,
    },
  },
  PatientHistoryV4: {
    default: {
      START: PatientHistoryV4I.Start,
      Action: PatientHistoryV4I.Action,
    },
  },
  RegistrationV4: {
    default: {
      START: RegistrationV4I.Start,
      Action: RegistrationV4I.Action,
    },
  },
  PackageV4: {
    default: {
      START: PackageV4I.Start,
      Action: PackageV4I.Action,
    },
  },
  BillingV4: {
    default: {
      START: BillingV4I.Start,
      Action: BillingV4I.Action,
    },
  },
  BillingHistoryV4: {
    default: {
      START: BillingHistoryV4I.Start,
      Action: BillingHistoryV4I.Action,
    },
  },
  BillingWalletV4: {
    default: {
      START: BillingWalletV4I.Start,
      Action: BillingWalletV4I.Action,
    },
  },
  TeleHealthV4: {
    default: {
      START: TeleHealthV4I.Start,
      Action: TeleHealthV4I.Action,
    },
  },
};

export default SequencePattern;
